<template>
<w-sliding-popup ref="periodPopup" width="960px" :title="title" @close="onClosePopup">
  <div class="comparison" slot="content">
    <w-common-line-chart v-for="(chart, index) in chartRscList" :key="chart.orderbyIndex" v-show="chart.visible" :style="getCommonChartStyle(index)" ref="commonLineChart"
      :added="chart.added" :rsc-info-list="chart.items" :orderby-index="chart.orderbyIndex" :realtime-flag="chart.realtimeFlag"
      :is-show-smart-analyzer-button="false" :is-show-compare-button="false" :is-show-stat-type="false" :is-show-delete-button="false"
      :legendPosition="legendPosition">
    </w-common-line-chart>
  </div>
</w-sliding-popup>
</template>

<script>
import ChartAnalaysisMixin from '@/mixins/chart/chart-analysis';
import forEach from 'lodash/forEach';
import WCommonLineChart from '@/views/chart/components/chart/CommonLineChart';

export default {
  name: 'WRealtimeChartPopup',
  mixins: [ChartAnalaysisMixin],
  components: {
    WCommonLineChart,
  },
  data() {
    return {
      title: '실시간 차트',
      chartRscList: [],
      legendPosition: 'bottom',
    };
  },
  watch: {
  },
  methods: {
    /**
     * [기간비교 그래프] 팝업창을 띄운다.
     * @return {[type]} [description]
     * @author jda
     */
    open(chartRscList) {
      this.chartRscList = chartRscList;
      this.$refs.periodPopup.visible = true;
    },
    /**
     * [기간비교 그래프] 팝업창을 닫는다.
     * @return {[type]} [description]
     * @author jda
     */
    onClosePopup() {
      forEach(this.$refs.commonLineChart, (item) => {
        item.onClickRealtimeStopButton();
      });
      this.$refs.periodPopup.visible = false;
    },

    getCommonChartStyle(index) {
      let style;
      if (this.dropzoneVisible) {
        style = 'margin-left: 0; margin-right: 0;';
      } else if (index < this.chartRscList.length - 1) {
        style = 'margin-bottom:50px;';
      } else {
        style = null;
      }
      return style;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/popup/RealtimeChartPopup/index.vue